<template>
  <v-dialog persistent v-model="value" max-width="1200px" scrollable>
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text" v-if="!isEdit">
          {{ $t('surveys.create_survey_title') }}
        </span>
        <span class="white--text" v-if="isEdit">
          {{ $t('surveys.edit_survey_title') }}
        </span>
      </v-card-title>
      <v-card-text style="max-height: 1200px">
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" :step="1">
                  {{ $t('surveys.survey') }}
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="e1 > 2" :step="2">
                  {{ $t('surveys.questions') }}
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="e1 > 3" :step="3">
                  {{ $t('surveys.catalog') }}
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="e1 > 4" :step="4">
                  {{ $t('surveys.audience') }}
                </v-stepper-step>
                <v-divider />
                <v-stepper-step :step="5">
                  {{ $t('surveys.preview') }}
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1">
                  <PollData
                    :poll="$v.pollForm"
                    :isEdit="isEdit"
                    @isInvalidDay="onIsInvalidDay"
                  />
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <PollQuestions
                    :poll="pollForm"
                    :isLocked="isLocked"
                    :isEdit="isEdit"
                  />
                </v-stepper-content>
                <v-stepper-content :step="3">
                  <PollStatus
                    :poll="pollForm"
                    :isLocked="isLocked"
                    :isEdit="isEdit"
                  />
                </v-stepper-content>
                <v-stepper-content :step="4">
                  <PollAudience
                    :cancel="flags.cancel"
                    :_object="pollForm"
                    @selected="selectionAudiency"
                    :isEdit="isEdit"
                  />
                </v-stepper-content>
                <v-stepper-content :step="5">
                  <PollDetail
                    :poll="pollForm"
                    @viewQuestions="viewQuestions"
                    :isEdit="isEdit"
                  />
                </v-stepper-content>
              </v-stepper-items>
              <alert
                v-model="toast.alert"
                title="Aviso"
                :description="toast.description"
              ></alert>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider v-if="e1 === 2 && !isLocked" />
      <v-card-actions v-if="e1 === 2 && !isLocked">
        <v-btn dark small fab slot="activator" @click="addQuestion">
          <v-icon>add</v-icon>
        </v-btn>
        <span> &nbsp;{{ $t('surveys.create_survey.add_question') }} </span>
      </v-card-actions>
      <v-card-actions>
        <v-btn
          v-if="disabled"
          :disabled="e1 == 1"
          color="primary"
          @click="back"
          icon
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" @click="close" flat>
          {{ $t('generic.cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="disabled"
          :disabled="isInvalidDay && e1 == 1"
          color="primary"
          @click="next"
          icon
          v-show="e1 != 5"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>
        <v-btn
          v-show="e1 == 5 && pollForm.publish == null"
          @click="next"
          color="error"
          style="text-transform: none"
        >
          {{ $t('generic.save') }}
        </v-btn>
        <v-btn
          v-show="e1 == 5 && pollForm.publish == false"
          @click="next"
          color="error"
          style="text-transform: none"
        >
          {{ $t('generic.save') }}
        </v-btn>
        <v-btn
          @click="next"
          v-show="e1 == 5 && pollForm.publish == true && isEdit == false"
          color="error"
          style="text-transform: none"
        >
          Programar
        </v-btn>

        <v-btn
          @click="next"
          v-show="e1 == 5 && pollForm.publish == true && isEdit == true"
          color="error"
          style="text-transform: none"
        >
          Actualizar
        </v-btn>
      </v-card-actions>
    </v-card>
    <desition
      @desition="$event ? createPoll() : ''"
      v-model="modals.confirmStatus"
      :title="modals.title"
      :description="modals.message"
    />
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import alert from '../../Dialogs/Alert'
import desition from '../../Dialogs/Delete'
import PollAudience from '../../Tools/Audience.vue'
import PollData from './PollData.vue'
import PollDetail from './PollDetail.vue'
import PollQuestions from './PollQuestions.vue'
import PollStatus from './PollStatus.vue'

export default {
  components: {
    alert,
    desition,
    PollData,
    PollQuestions,
    PollAudience,
    PollDetail,
    PollStatus,
  },
  validations: {
    pollForm: {
      title: { required },
      periodicity: { required },
      startDate: { required },
      endDate: {},
      audience: { required },
      questions: [],
    },
  },
  props: ['value', 'typePoll', 'poll', 'isEdit', 'edit'],
  watch: {
    value() {
      if (this.value && this.flags.cancel) {
        this.flags.cancel = false
      }

      if (this.poll !== null && this.value) {
        this.getPoll(this.poll.id)
      }

      if (this.value && this.typePoll === 'COVID') {
        this.isLocked = true
        this.pollForm.questions = this.questionsCovid()
      } else {
        this.isLocked = false
      }
    },
    typePoll() {
      if (this.typePoll === 'COVID') {
        this.isLocked = true
        this.pollForm.questions = this.questionsCovid()
      } else {
        this.isLocked = false
      }
    },
    poll() {
      if (this.poll !== null && this.value) {
        this.getPoll(this.poll.id)
      }
    },
  },
  data: () => ({
    isInvalidDay: true,
    e1: 0,
    pollForm: {
      title: '',
      periodicity: '',
      startDate: '',
      endDate: '',
      questions: [
        {
          question: '',
          type: '',
          answers: [
            { answer: '', alert: false },
            { answer: '', alert: '' },
          ],
        },
      ],
      audience: {
        institutional: false,
      },
      publish: false,
      levels: [],
      students: [],
      subgroupIds: [],
      webRoleIds: [],
      groups: [],
      theEmailsToNotify: [],
      chipData: [],
    },
    toast: {
      alert: false,
      description: '',
    },
    flags: {
      cancel: false,
      loading: false,
    },
    disabled: true,
    isLocked: false,
    modals: {
      confirmStatus: false,
      title: '',
      message: '',
    },
  }),
  methods: {
    onIsInvalidDay(e) {
      this.isInvalidDay = e
    },
    getPoll(idPoll) {
      this.$store
        .dispatch('polls/getPollFull', idPoll)
        .then((response) => {
          this.$emit('loading', false)
          this.editPoll(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    editPoll(editP) {
      this.isLocked = editP.isLocked
      this.pollForm = editP
      this.pollForm.levels = editP.audienceDesc.levels
      this.pollForm.students = editP.audienceDesc.students
      this.pollForm.groups = editP.audienceDesc.gradeGroups
      this.pollForm.subgroupIds = editP.audienceDesc.subgroups
      this.pollForm.webRoleIds = editP.audienceDesc.webRoles
      if (this.pollForm.status == 'READY') {
        this.pollForm.publish = true
      } else {
        this.pollForm.publish = false
      }
      if (editP.notifyByEmail == true) {
        this.pollForm.theEmailsToNotify = editP.emailsToNotify.split(',')
        this.pollForm.chipData = this.pollForm.theEmailsToNotify
      } else {
        this.pollForm.theEmailsToNotify = []
        this.pollForm.chipData = []
      }
    },
    viewQuestions() {
      this.e1 = 3
    },
    addQuestion() {
      this.pollForm.questions.push({
        question: '',
        type: '',
        answers: [{ answer: '' }, { answer: '' }],
      })
      //let _modal = document.getElementById('question-id');
      //_modal.scrollTo(100, _modal.scrollHeight + 100);
    },
    selectionAudiency(event) {
      this.pollForm.levels = event.levels
      this.pollForm.groups = event.ggs
      this.pollForm.subgroupIds = event.subgroupIds
      this.pollForm.webRoleIds = event.webRoleIds
      this.pollForm.students = event.students
      this.pollForm.audience.institutional = event.institutional
    },
    close() {
      this.$v.pollForm.startDate.$model = ''
      this.$v.pollForm.endDate.$model = ''
      this.pollForm = {
        title: '',
        startDate: '',
        endDate: '',
        periodicity: '',
        questions: [],
        audience: {
          institutional: false,
        },
        publish: '',
        levels: [],
        students: [],
        subgroupIds: [],
        webRoleIds: [],
        groups: [],
        theEmailsToNotify: [],
        chipData: [],
      }
      this.flags.cancel = true
      this.e1 = 1
      this.$v.pollForm.$reset()
      this.$emit('onClosed', false)
    },
    next() {
      switch (this.e1) {
        case 1:
          this.$v.pollForm.title.$touch()
          this.$v.pollForm.periodicity.$touch()
          this.$v.pollForm.startDate.$touch()
          if (
            !this.$v.pollForm.title.$invalid &&
            !this.$v.pollForm.startDate.$invalid &&
            !this.$v.pollForm.periodicity.$invalid
          ) {
            if (this.pollForm.questions.length === 0) {
              this.addQuestion()
            }
            this.e1++
          }
          this.answersBack()
          break
        case 2:
          this.answersBack()
          if (this.pollForm.periodicity == 'SINGLE') {
            this.pollForm.endDate = ''
          }
          if (this.validQuestions()) {
            this.e1++
          } else {
            this.toast.alert = true
          }
          break
        case 3:
          this.e1++
          break
        case 4:
          if (
            this.pollForm.students.length > 0 ||
            this.pollForm.groups.length > 0 ||
            this.pollForm.levels.length > 0 ||
            this.pollForm.subgroupIds.length > 0 ||
            this.pollForm.webRoleIds.length > 0 ||
            this.pollForm.audience.institutional
          ) {
            this.e1++
          } else {
            this.toast.description =
              'Debes agregar ya sea la institución o al menos un nivel, grupo o estudiante'
            this.toast.alert = true
          }
          //} else {
          //this.createPoll();
          //}
          break
        case 5:
          if (
            this.pollForm.notifyByEmail == true &&
            this.pollForm.theEmailsToNotify.length == 0
          ) {
            this.toast.description =
              'Asegúrate de agregar al menos un correo electrónico o deshabilita la opción de notificaciones por correo'
            this.toast.alert = true
          } else {
            if (this.pollForm.publish == true && this.edit == false) {
              //Publicar
              this.condicitionG()
            }
            if (this.pollForm.publish == true && this.edit == true) {
              this.condicitionA()
            }
            if (this.pollForm.publish == false) {
              //Guardar
              this.condicitionP()
            }
            /*
              if (condition) {
                this.createPoll();
              }
              */
          }
          break
      }
    },
    condicitionP() {
      this.modals.confirmStatus = true
      this.modals.title = 'Aviso'
      this.modals.message =
        'Esta encuesta no será publicada y se guardará como borrador'
    },
    condicitionA() {
      this.modals.confirmStatus = true
      this.modals.title = 'Aviso'
      this.modals.message = 'Esta encuesta sera actualizada'
    },
    condicitionG() {
      this.modals.confirmStatus = true
      this.modals.title = 'Aviso'
      this.modals.message =
        'Esta encuesta será publicada para la audiencia seleccionada en el rango de fechas y horas establecidas'
    },
    validQuestions() {
      let validations = {
        isFormValid: true,
        message: '',
      }
      this.questionsAreValid(validations)
      if (!validations.isFormValid) {
        this.toast.description = validations.message
        return false
      }
      this.answersAreValid(validations)
      if (!validations.isFormValid) {
        this.toast.description = validations.message
        return false
      }
      return validations.isFormValid
    },
    questionsAreValid(validations) {
      var questionEmpty = []
      var typesEmpty = []
      this.pollForm.questions.forEach(function callback(question, index) {
        if (question.question === '') {
          questionEmpty.push(' ' + (index + 1))
        } else if (question.type === '') {
          typesEmpty.push(' ' + (index + 1))
        }
      })
      if (questionEmpty.length === 1) {
        validations.isFormValid = false
        validations.message =
          'La pregunta' + questionEmpty.toString() + ' está vacía'
        return
      } else if (questionEmpty.length > 1) {
        validations.isFormValid = false
        validations.message =
          'Las preguntas' + questionEmpty.toString() + ' están vacías'
        return
      }
      if (typesEmpty.length === 1) {
        validations.isFormValid = false
        validations.message =
          'La pregunta' + typesEmpty.toString() + ' no tiene tipo'
        return
      } else if (typesEmpty.length > 1) {
        validations.isFormValid = false
        validations.message =
          'Las preguntas' + typesEmpty.toString() + ' no tienen tipo'
        return
      }
    },
    answersBack() {
      for (let index = 0; index < this.pollForm.questions.length; index++) {
        if (this.pollForm.questions[index].type == 'TEXT') {
          this.pollForm.questions[index].answers = [
            { answer: '' },
            { answer: '' },
          ]
        }
      }
    },
    answersAreValid(validations) {
      var BreakException = {}
      var answerEmpty = []
      try {
        this.pollForm.questions.forEach(function callback(question, index) {
          question.answers.forEach(function callback(answer, indexAnswer) {
            if (question.type == 'TEXT') {
              question.answers = null
            } else {
              if (answer.answer === '') {
                answerEmpty.push(' ' + (indexAnswer + 1))
              }
            }
          })
          if (answerEmpty.length === 1) {
            question = index + 1
            validations.isFormValid = false
            validations.message =
              'La respuesta ' +
              answerEmpty.toString() +
              ' de la pregunta ' +
              (index + 1) +
              ' está vacía'
            throw BreakException
          } else if (answerEmpty.length > 1) {
            question = index + 1
            validations.isFormValid = false
            validations.message =
              'Las respuestas ' +
              answerEmpty.toString() +
              ' de la pregunta ' +
              (index + 1) +
              ' están vacías'
            throw BreakException
          }
        })
      } catch (e) {
        if (e !== BreakException) throw e
      }
    },
    back() {
      this.e1--
      if (this.e1 == 2) {
        this.answersBack()
      }
    },
    createPoll() {
      const isCovidPoll = this.typePoll == 'COVID'
      this.disabled = false
      this.$emit('loading', true)

      for (let index = 0; index < this.pollForm.questions.length; index++) {
        if (this.pollForm.questions[index].type == 'TEXT') {
          this.pollForm.questions[index].answers = null
        }
      }
      if (isCovidPoll && this.pollForm.webRoleIds != '') {
        this.pollForm.questions[0].question =
          '¿Usted presenta alguno de los siguientes síntomas?'
      }

      var poll = {
        title: this.pollForm.title,
        startDate: this.pollForm.startDate,
        periodicity: this.pollForm.periodicity,
        publish: this.pollForm.publish ? true : false,
        questions: this.pollForm.questions,
        isLocked: this.isLocked,
        institutional: this.pollForm.audience.institutional,
        levelIds: (this.pollForm.levels || []).map((lvl) => lvl.id),
        gradeGroupIds: (this.pollForm.groups || []).map((gg) => gg.id),
        studentIds: (this.pollForm.students || []).map((std) => std.id),
        subgroupIds: (this.pollForm.subgroupIds || []).map((sg) => sg.id),
        webRoleIds: (this.pollForm.webRoleIds || []).map((sg) => sg.id),
        requiredForEntry: this.pollForm.requiredForEntry || false,
        notifyByEmail: this.pollForm.notifyByEmail || false,
        theEmailsToNotify: this.pollForm.theEmailsToNotify || [],
      }
      if (this.pollForm.endDate !== '') {
        poll.endDate = this.pollForm.endDate
      }

      if (this.edit) {
        poll.id = this.pollForm.id
        this.$store
          .dispatch('polls/PollUpdate', poll)
          .then(() => {
            this.disabled = true
            this.$v.pollForm.$reset()
            this.close()
            this.$emit('created', { success: true })
          })
          .catch(() => {
            this.disabled = true
            this.$emit('created', { success: false })
          })
      } else {
        this.$store
          .dispatch('polls/createPoll', poll)
          .then(() => {
            if (isCovidPoll) {
              GoogleAnalytics.actionEvent({
                eventName: 'created_covid_poll',
                eventDescription: 'Encuesta covid creada',
              })
            } else {
              GoogleAnalytics.actionEvent({
                eventName: 'created_poll',
                eventDescription: 'Encuesta creada',
              })
            }
            console.log('bien en metodo')
            this.disabled = true
            this.$v.pollForm.$reset()
            this.close()
            this.$emit('created', { success: true })
          })
          .catch(() => {
            console.log('mal en metodo')
            this.disabled = true
            this.$emit('created', { success: false })
          })
      }
    },
    questionsCovid() {
      var questions = [
        {
          question: this.$t('surveys.create_survey.covid_question'),
          type: 'MULTIPLE',
          answers: [
            { answer: this.$t('surveys.create_survey.dry_cough') },
            { answer: this.$t('surveys.create_survey.headache') },
            { answer: this.$t('surveys.create_survey.difficulty_breathing') },
            { answer: this.$t('surveys.create_survey.general_discomfort') },
            { answer: this.$t('surveys.create_survey.sore_throat') },
            { answer: this.$t('surveys.create_survey.temperature') },
            { answer: this.$t('surveys.create_survey.no_symptoms') },
            // { answer: 'Tos seca' },
            // { answer: 'Dolor de cabeza' },
            // { answer: 'Dificultad para respirar' },
            // { answer: 'Malestar general' },
            // { answer: 'Dolor de garganta' },
            // { answer: 'Temperatura' },
            // { answer: 'No presenta síntomas' },
          ],
        },
      ]
      return questions
    },
  },
}
</script>

<style></style>
